<template>
    <BaseModal
        class="event-modal"
        transition-name="event-modal"
        v-bind="$attrs"
        @close="closeModal"
    >
        <template #close-button>
            <div class="modal__close">
                <BaseButton
                    class="modal__close-button"
                    @click="closeModal"
                >
                    <BaseIcon icon="cross" />
                </BaseButton>
            </div>
        </template>

        <template #default>
            <slot />
        </template>
    </BaseModal>
</template>

<script setup>
const emit = defineEmits(['close']);

const closeModal = () => emit('close');
</script>

<style lang="less" src="./EventModal.less" />
